import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import {
  AddVehicle,
  EditVehicle,
  GetVehicle,
  GetAllVehicleBrands,
  GetVehicleClassesByBrand,
  Upload,
} from "../../fetchs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useStyles = (theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  labelAsterisk: {
    color: "red",
  },
  cssLabel: {
    color: "orange",
  },
  cssRequired: {
    "&:before": {
      borderBottom: "2px solid orange",
    },
  },
});

const Vehicle = (props) => {
  const [uploadPic, setuploadPic] = useState("");
  const [vehicleBrands, setvehicleBrands] = useState([]);
  const [vehicleClasses, setvehicleClasses] = useState([]);
  const [loading, setloading] = useState(false);
  const [saving, setsaving] = useState(false);
  const [openSnackbar, setopenSnackbar] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");
  const [nameHelper, setnameHelper] = useState("");
  const [vehicle, setvehicle] = useState({
    id: "",
    name: "",

    imageAddress: "",
    vehicleBrandId: null,
    vehicleClassId: null,
    item1: "",
    item2: "",
    item3: "",
    item4: "",
    item5: "",
    item6: "",
    item7: "",
    item8: "",
    item9: "",
    item10: "",
    item11: "",
    item12: "",
    item13: "",
    item14: "",
    item15: "",
    item16: "",
    item17: "",
    item18: "",
    item19: "",
    item20: "",
    item21: "",
    description: "",
  });
  const {
    id,
    name,
    imageAddress,
    vehicleBrandId,
    vehicleClassId,
    item1,
    item2,
    item3,
    item4,
    item5,
    item6,
    item7,
    item8,
    item9,
    item10,
    item11,
    item12,
    item13,
    item14,
    item15,
    item16,
    item17,
    item18,
    item19,
    item20,
    item21,
    description,
  } = vehicle;

  const handleCloseSnackbar = () => {
    openSnackbar(false);
  };

  useEffect(() => {
    const vehicleId = props.match.params.vehicleId;
    if (vehicleId) {
      loadVehicle(vehicleId);
    }

    GetAllVehicleBrands()
      .then((response) => {
        setloading(false);

        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message) {
          seterrorMessage(responseJson.Message);
          setopenSnackbar(true);
        } else setvehicleBrands(responseJson);
      })
      .catch((error) => {
        setloading(false);
        console.log(error);
      });
  }, []);

  const loadVehicle = (vehicleId) => {
    setloading(true);
    GetVehicle(vehicleId)
      .then((response) => {
        setloading(false);
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message) {
          seterrorMessage(responseJson.Message);
          setopenSnackbar(true);
        } else
          setvehicle(
            {
              id: responseJson.id,
              name: responseJson.name,
              imageAddress: responseJson.imageAddress,
              vehicleBrandId: responseJson.vehicleBrandId,
              vehicleClassId: responseJson.vehicleClassId,
              item1: responseJson.item1,
              item2: responseJson.item2,
              item3: responseJson.item3,
              item4: responseJson.item4,
              item5: responseJson.item5,
              item6: responseJson.item6,
              item7: responseJson.item7,
              item8: responseJson.item8,
              item9: responseJson.item9,
              item10: responseJson.item10,
              item11: responseJson.item11,
              item12: responseJson.item12,
              item13: responseJson.item13,
              item14: responseJson.item14,
              item15: responseJson.item15,
              item16: responseJson.item16,
              item17: responseJson.item17,
              item18: responseJson.item18,
              item19: responseJson.item19,
              item20: responseJson.item20,
              item21: responseJson.item21,
              description: responseJson.description,
            }
            // () => {
            //   getVehicleClassesByBrand();
            // }
          );
      })
      .catch((error) => {
        setloading(false);
        console.log(error);
      });
  };

  const handleSave = () => {
    if (props.match.params.vehicleId) editVehicle();
    else addVehicle();
  };

  const addVehicle = () => {
    AddVehicle({
      name: name,
      imageAddress: imageAddress,
      vehicleBrandId: vehicleBrandId,
      vehicleClassId: vehicleClassId,
      item1: item1,
      item2: item2,
      item3: item3,
      item4: item4,
      item5: item5,
      item6: item6,
      item7: item7,
      item8: item8,
      item9: item9,
      item10: item10,
      item11: item11,
      item12: item12,
      item13: item13,
      item14: item14,
      item15: item15,
      item16: item16,
      item17: item17,
      item18: item18,
      item19: item19,
      item20: item20,
      item21: item21,
      description: description,
    })
      .then((response) => {
        if (response.status !== 200) {
          toast.error("خطای اضافه شدن اتومبیل");
        } else if (response.status === 200) {
          toast.success(" اتومبیل با موفقیت اضافه شد");
          this.props.history.push("/main/vehicles");
        }
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message) {
          seterrorMessage(responseJson.Message);
          setopenSnackbar(true);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const editVehicle = () => {
    EditVehicle({
      id: props.match.params.vehicleId,
      name: name,
      imageAddress: imageAddress,
      vehicleBrandId: vehicleBrandId,
      vehicleClassId: vehicleClassId,
      item1: item1,
      item2: item2,
      item3: item3,
      item4: item4,
      item5: item5,
      item6: item6,
      item7: item7,
      item8: item8,
      item9: item9,
      item10: item10,
      item11: item11,
      item12: item12,
      item13: item13,
      item14: item14,
      item15: item15,
      item16: item16,
      item17: item17,
      item18: item18,
      item19: item19,
      item20: item20,
      item21: item21,
      description: description,
    })
      .then((response) => {
        if (response.status !== 200) {
          toast.error("خطای ویرایش شدن اتومبیل");
        } else if (response.status === 200) {
          toast.success(" اتومبیل با موفقیت ویرایش شد");
          this.props.history.push("/main/vehicles");
        }
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message) {
          seterrorMessage(responseJson.Message);
          setopenSnackbar(true);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleChange = (name) => (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    event.persist();
    setvehicle((prevState) => ({ ...prevState, [name]: value }));

    // setProduct({ [name]: value });
  };
  //   handleChange = (name) => (event) => {
  //     setvehicle({ [name]: event.target.value });
  //   };

  const handleBrandChange = (name) => (event) => {
    setvehicle({ ...vehicle, [name]: event.target.value });
    // getVehicleClassesByBrand();
  };

  useEffect(() => {
    GetVehicleClassesByBrand(vehicleBrandId)
      .then((response) => {
        setloading(false);
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message) {
          seterrorMessage(responseJson.Message);
          setopenSnackbar(true);
        } else setvehicleClasses(responseJson);
      })
      .catch((error) => {
        setloading(false);
        console.log(error);
      });
  }, [vehicleBrandId]);
  //   const getVehicleClassesByBrand = () => {
  //     GetVehicleClassesByBrand(vehicleBrandId)
  //       .then((response) => {
  //         setloading(false);
  //         return response.json();
  //       })
  //       .then((responseJson) => {
  //         if (responseJson.Message) {
  //           seterrorMessage(responseJson.Message);
  //           setopenSnackbar(true);
  //         } else setvehicleClasses(responseJson);
  //       })
  //       .catch((error) => {
  //         setloading(false);
  //         console.log(error);
  //       });
  //   };

  // handleSelectFile = (event) => {
  //   Upload(event.target.files[0], "goods")
  //     .then((response) => {
  //       return response.text();
  //     })

  //     .then((responseJson) => {
  //       setState({ imageAddress: responseJson });
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // };

  const handleSelectFile = (name) => (event) => {
    Upload(event.target.files[0], "goods")
      .then((response) => {
        return response.text();
      })
      .then((responseJson) => {
        setvehicle({ ...vehicle, [name]: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const onChange = (event) => {
    let valid;

    event.persist();

    switch (event.target.id) {
      case "name":
        event.persist();
        setvehicle((prevState) => ({
          ...prevState,
          name: event.target.value,
        }));
        valid = event.target.value.length > 0;
        if (!valid) {
          setnameHelper("لطفا نام ماشین را وارد کنید");
        } else {
          setnameHelper("");
        }
        break;

      default:
        break;
    }
  };

  const { classes } = props;
  return (
    <React.Fragment>
      <CssBaseline />
      <main className={classes.layout}>
        <Paper className={classes.paper}>
          {props.match.params.vehicleId ? (
            <Typography component="h1" variant="h4" align="center">
              ویرایش ماشین
            </Typography>
          ) : (
            <Typography component="h1" variant="h4" align="center">
              افزودن ماشین جدید
            </Typography>
          )}
          <React.Fragment>
            <form className={classes.container} noValidate autoComplete="off">
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    error={nameHelper.length !== 0}
                    helperText={nameHelper}
                    onChange={onChange}
                    id="name"
                    label="نام"
                    name="name"
                    required
                    fullWidth
                    className={classes.textField}
                    value={name}
                    InputLabelProps={
                      name.length === 0
                        ? {
                            classes: {
                              root: classes.cssLabel,
                            },
                            FormLabelClasses: {
                              asterisk: classes.labelAsterisk,
                            },
                          }
                        : ""
                    }
                    InputProps={
                      name.length === 0
                        ? {
                            classes: {
                              underline: classes.cssRequired,
                            },
                          }
                        : ""
                    }
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div>
                    <input
                      accept="image/*"
                      className={classes.input}
                      style={{ display: "none" }}
                      id="i"
                      type="file"
                      name="imageAddress"
                      onChange={handleSelectFile("imageAddress")}
                    />
                    <label htmlFor="i">
                      <Button
                        fullWidth
                        variant="contained"
                        component="span"
                        className={classes.button}
                      >
                        ارسال عکس
                      </Button>
                      {uploadPic && (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                    </label>
                  </div>
                  <div>
                    <div className="picParent">
                      <img
                        src={`http://test.asa-oil.ir/${imageAddress}`}
                        className="picture"
                        alt={name}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    InputLabelProps={
                      vehicleBrandId === null
                        ? {
                            classes: {
                              root: classes.cssLabel,
                            },
                            FormLabelClasses: {
                              asterisk: classes.labelAsterisk,
                            },
                          }
                        : ""
                    }
                    InputProps={
                      vehicleBrandId === null
                        ? {
                            classes: {
                              underline: classes.cssRequired,
                            },
                          }
                        : ""
                    }
                    id="standard-select-vahicle-brand"
                    select
                    label="برند خودرو"
                    required
                    fullWidth
                    name="vehicleBrandId"
                    className={classes.textField}
                    value={vehicleBrandId}
                    onChange={handleBrandChange("vehicleBrandId")}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                      },
                    }}
                    margin="normal"
                  >
                    {vehicleBrands.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    InputLabelProps={
                      vehicleClassId === null
                        ? {
                            classes: {
                              root: classes.cssLabel,
                            },
                            FormLabelClasses: {
                              asterisk: classes.labelAsterisk,
                            },
                          }
                        : ""
                    }
                    InputProps={
                      vehicleClassId === null
                        ? {
                            classes: {
                              underline: classes.cssRequired,
                            },
                          }
                        : ""
                    }
                    id="standard-select-vahicle-class"
                    select
                    label="کلاس خودرو"
                    required
                    fullWidth
                    name="vehicleClassId"
                    className={classes.textField}
                    value={vehicleClassId}
                    onChange={handleChange("vehicleClassId")}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                      },
                    }}
                    margin="normal"
                  >
                    {vehicleClasses.map((option) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="item1"
                    name="item1"
                    label="حجم روغن موتور با تعویض فیلتر روغن"
                    fullWidth
                    className={classes.textField}
                    value={item1}
                    onChange={handleChange("item1")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="item2"
                    name="item2"
                    label="سطح کیفیت مناسب روغن موتور"
                    fullWidth
                    className={classes.textField}
                    value={item2}
                    onChange={handleChange("item2")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="item3"
                    id="item3"
                    label="حجم جعبه دنده اتوماتیک"
                    fullWidth
                    className={classes.textField}
                    value={item3}
                    onChange={handleChange("item3")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="item4"
                    name="item4"
                    label="سطح کیفیت جعبه دنده اتوماتیک"
                    fullWidth
                    className={classes.textField}
                    value={item4}
                    onChange={handleChange("item4")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="item5"
                    id="standard-item5"
                    label="حجم جعبه دنده دستی"
                    fullWidth
                    className={classes.textField}
                    value={item5}
                    onChange={handleChange("item5")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="item6"
                    id="standard-item6"
                    label="سطح کیفیت جعبه دنده دستی"
                    fullWidth
                    className={classes.textField}
                    value={item6}
                    onChange={handleChange("item6")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="item7"
                    id="standard-item7"
                    label="حجم رادیات (سیستم خنک کننده)"
                    fullWidth
                    className={classes.textField}
                    value={item7}
                    onChange={handleChange("item7")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="item8"
                    id="standard-item8"
                    label="مایع رادیات مناسب"
                    fullWidth
                    className={classes.textField}
                    value={item8}
                    onChange={handleChange("item8")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="item9"
                    id="standard-item9"
                    label="روغن ترمز مناسب"
                    fullWidth
                    className={classes.textField}
                    value={item9}
                    onChange={handleChange("item9")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="item10"
                    id="standard-item10"
                    label="حجم هیدرولیک فرمان"
                    fullWidth
                    className={classes.textField}
                    value={item10}
                    onChange={handleChange("item10")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="item11"
                    id="standard-item11"
                    label="نوع هیدرولیک فرمان"
                    fullWidth
                    className={classes.textField}
                    value={item11}
                    onChange={handleChange("item11")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="item12"
                    id="standard-item12"
                    label="دیفرانسیل / حجم و نوع"
                    fullWidth
                    className={classes.textField}
                    value={item12}
                    onChange={handleChange("item12")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="item13"
                    id="standard-item13"
                    label="روغن موتور پیشنهادی"
                    fullWidth
                    className={classes.textField}
                    value={item13}
                    onChange={handleChange("item13")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="item14"
                    id="standard-item14"
                    label="فیلتر نوع اول"
                    fullWidth
                    className={classes.textField}
                    value={item14}
                    onChange={handleChange("item14")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="item15"
                    id="standard-item15"
                    label="فیلتر نوع  دوم"
                    fullWidth
                    className={classes.textField}
                    value={item15}
                    onChange={handleChange("item15")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="item16"
                    id="standard-item16"
                    label="فیلتر نوع سوم"
                    fullWidth
                    className={classes.textField}
                    value={item16}
                    onChange={handleChange("item16")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    name="item17"
                    id="standard-item17"
                    label="فیلتر نوع  چهارم"
                    fullWidth
                    className={classes.textField}
                    value={item17}
                    onChange={handleChange("item17")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div>
                    <input
                      accept="image/*"
                      className={classes.input}
                      style={{ display: "none" }}
                      id="1"
                      type="file"
                      name="item18"
                      onChange={handleSelectFile("item18")}
                    />
                    <label htmlFor="1">
                      <Button
                        fullWidth
                        variant="contained"
                        component="span"
                        className={classes.button}
                      >
                        (1) عکس فیلتر
                      </Button>
                      {uploadPic && (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                    </label>
                  </div>
                  <div>
                    <div className="picParent">
                      <img
                        src={`http://test.asa-oil.ir/${item18}`}
                        className="picture"
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div>
                    <input
                      accept="image/*"
                      className={classes.input}
                      style={{ display: "none" }}
                      id="2"
                      type="file"
                      name="item19"
                      onChange={handleSelectFile("item19")}
                    />
                    <label htmlFor="2">
                      <Button
                        fullWidth
                        variant="contained"
                        component="span"
                        className={classes.button}
                      >
                        (2) عکس فیلتر
                      </Button>
                      {uploadPic && (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                    </label>
                  </div>
                  <div>
                    <div className="picParent">
                      <img
                        src={`http://test.asa-oil.ir/${item19}`}
                        className="picture"
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div>
                    <input
                      accept="image/*"
                      className={classes.input}
                      style={{ display: "none" }}
                      id="3"
                      type="file"
                      name="item20"
                      onChange={handleSelectFile("item20")}
                    />
                    <label htmlFor="3">
                      <Button
                        fullWidth
                        variant="contained"
                        component="span"
                        className={classes.button}
                      >
                        (3) عکس فیلتر
                      </Button>
                      {uploadPic && (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                    </label>
                  </div>
                  <div>
                    <div className="picParent">
                      <img
                        src={`http://test.asa-oil.ir/${item20}`}
                        className="picture"
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <div>
                    <input
                      accept="image/*"
                      className={classes.input}
                      style={{ display: "none" }}
                      id="4"
                      type="file"
                      name="item21"
                      onChange={handleSelectFile("item21")}
                    />
                    <label htmlFor="4">
                      <Button
                        fullWidth
                        variant="contained"
                        component="span"
                        className={classes.button}
                      >
                        (4) عکس فیلتر
                      </Button>
                      {uploadPic && (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                    </label>
                  </div>
                  <div>
                    <div className="picParent">
                      <img
                        src={`http://test.asa-oil.ir/${item21}`}
                        className="picture"
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name="description"
                    id="standard-description"
                    label="توضیحات"
                    fullWidth
                    multiline
                    rows="4"
                    className={classes.textField}
                    value={description}
                    onChange={handleChange("description")}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={
                      loading ||
                      nameHelper.length !== 0 ||
                      name.length === 0 ||
                      vehicleBrandId === null ||
                      vehicleClassId === null
                    }
                    onClick={handleSave}
                  >
                    ذخیره
                  </Button>
                </Grid>
              </Grid>
            </form>
          </React.Fragment>
        </Paper>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          autoHideDuration={3000}
          open={openSnackbar}
          ContentProps={{
            "aria-describedby": "message-id",
            class:
              "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
          }}
          message={<span id="message-id"> {errorMessage} </span>}
          onClose={() => handleCloseSnackbar(false)}
        />
      </main>
    </React.Fragment>
  );
};

Vehicle.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Vehicle));
